import Vue from 'vue'
import Router from 'vue-router'

// Commom Components
import Login from '@/components/Login'
import LoginForgot from '@/components/LoginForgot'
import LoginNewPassword from '@/components/LoginNewPassword'
import Signup from '@/components/Signup'
import Account from '@/components/Account'

// Admin Components
import AdminOverview from '@/components/admin/AdminOverview'
import AdminUsers from '@/components/admin/AdminUsers'
import AdminUserShow from '@/components/admin/AdminUserShow'
import AdminExercises from '@/components/admin/AdminExercises'
import AdminTrainings from '@/components/admin/AdminTrainings'
import AdminNewTraining from '@/components/admin/trainings/AdminNewTraining'
import AdminEditTraining from '@/components/admin/trainings/AdminEditTraining'
import AdminSupport from '@/components/admin/AdminSupport'
import AdminCalendar from '@/components/admin/AdminCalendar'
import AdminTicketShow from '@/components/admin/support/AdminTicketShow'
import AdminNotifications from '@/components/admin/AdminNotifications'
import AdminFinancial from '@/components/admin/AdminFinancial'

// User Components
import UserOverview from '@/components/user/UserOverview'
import UserTrainings from '@/components/user/UserTrainings'
import UserEvaluations from '@/components/user/UserEvaluations'
import UserSupport from '@/components/user/UserSupport'
import UserFinancial from '@/components/user/UserFinancial'

// Declarations
let currentUserIsAdmin = false
let currentUser, routes

// Check is user is a admin
if (localStorage.getItem('currentUser')) {
  currentUser = JSON.parse(localStorage.getItem('currentUser'))
  if (currentUser.roles) {
    currentUserIsAdmin = currentUser.roles.indexOf('admin') !== -1
  } else {
    currentUserIsAdmin = false
  }
}

Vue.use(Router)

// Set Commom Routes
let defaultRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/login/forgot',
    name: 'LoginForgot',
    component: LoginForgot
  },
  {
    path: '/forgot/new_password',
    name: 'LoginNewPassword',
    component: LoginNewPassword
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup
  },
  {
    path: '/account',
    name: 'Account',
    component: Account
  },
  {
    path: '/ticket/:id',
    name: 'AdminTicketShow',
    component: AdminTicketShow
  },
  {
    path: '/calendar',
    name: 'AdminCalendar',
    component: AdminCalendar
  }
]

if (currentUserIsAdmin) {
  // Admin Routes
  routes = defaultRoutes.concat([
    {
      path: '/',
      name: 'AdminOverview',
      component: AdminOverview
    },
    {
      path: '/users',
      name: 'AdminUsers',
      component: AdminUsers
    },
    {
      path: '/user/:id',
      name: 'AdminUserShow',
      component: AdminUserShow
    },
    {
      path: '/exercises',
      name: 'AdminExercises',
      component: AdminExercises
    },
    {
      path: '/trainings',
      name: 'AdminTrainings',
      component: AdminTrainings
    },
    {
      path: '/trainings/new',
      name: 'AdminNewTraining',
      component: AdminNewTraining
    },
    {
      path: '/trainings/:id',
      name: 'AdminEditTraining',
      component: AdminEditTraining
    },
    {
      path: '/support',
      name: 'AdminSupport',
      component: AdminSupport
    },
    {
      path: '/notifications',
      name: 'AdminNotifications',
      component: AdminNotifications
    },
    {
      path: '/financial',
      name: 'AdminFinancial',
      component: AdminFinancial
    }
  ])
} else {
  // User (aluno) Routes
  routes = defaultRoutes.concat([
    {
      path: '/',
      name: 'UserOverview',
      component: UserOverview
    },
    {
      path: '/trainings',
      name: 'UserTrainings',
      component: UserTrainings
    },
    {
      path: '/evaluations',
      name: 'UserEvaluations',
      component: UserEvaluations
    },
    {
      path: '/support',
      name: 'UserSupport',
      component: UserSupport
    },
    {
      path: '/financial',
      name: 'UserFinancial',
      component: UserFinancial
    }
  ])
}

export default new Router({
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index.js